import * as React from 'react';

import { translate } from '~l10n/client';

import { IconButton } from '~shared/components/buttons';
import { IconChevron } from '~shared/components/icons/standard';
import { Inline } from '~shared/components/Inline';

export type changeStudentHandler = (newStudentId: number) => void;

function checkAreStudentIdsUnique(studentIds: number[]) {
  if (new Set(studentIds.filter(Boolean)).size !== studentIds.length) {
    throw new Error('Student Ids must be unique and not null or undefined.');
  }
}

export function StudentScoreNavigation({
  currentStudentId,
  studentIds,
  isDisabled,
  changeStudent,
}: {
  currentStudentId: number;
  studentIds: Array<number>;
  isDisabled: boolean;
  changeStudent: changeStudentHandler;
}) {
  React.useEffect(() => {
    checkAreStudentIdsUnique(studentIds);
  }, [studentIds]);

  const currentIndex = studentIds.findIndex(
    (studentId) => studentId === currentStudentId
  );

  if (currentIndex === -1) {
    throw new Error('current studentId does not exist in supplied studentIds');
  }

  const isFirstIndex = currentIndex === 0;
  const isLastIndex = currentIndex === studentIds.length - 1;

  const nextStudent = () => {
    if (isLastIndex) return;
    const nextStudentId = studentIds[currentIndex + 1];
    changeStudent(nextStudentId);
  };

  const previousStudent = () => {
    if (isFirstIndex) return;
    const nextStudentId = studentIds[currentIndex - 1];
    changeStudent(nextStudentId);
  };

  return (
    <Inline>
      <IconButton
        disabled={isDisabled || isFirstIndex}
        aria-label={translate('Previous Student')}
        appearance="secondary"
        onClick={previousStudent}
      >
        <IconChevron direction="up" />
      </IconButton>
      <IconButton
        disabled={isDisabled || isLastIndex}
        aria-label={translate('Next Student')}
        appearance="secondary"
        onClick={nextStudent}
      >
        <IconChevron direction="down" />
      </IconButton>
    </Inline>
  );
}
